// Test IDs for admin dashboard.
export const ADMIN = {
	// Nav
	navDashboard: 'admin-nav-dashboard',
	navStores: 'admin-nav-stores',
	navProducts: 'admin-nav-products',
	navTransactions: 'admin-nav-transactions',
	navSnippet: 'admin-nav-snippet',
	logoutButton: 'admin-logout-button',

	// Login
	loginEmailInput: 'admin-login-email-input',
	loginPasswordInput: 'admin-login-password-input',
	loginSubmitButton: 'admin-login-submit-button',
	loginErrorMessage: 'admin-login-error-message',

	// Dashboard stats
	statRevenue: 'admin-stat-revenue',
	statOrders: 'admin-stat-orders',
	statStores: 'admin-stat-stores',
	statProducts: 'admin-stat-products',

	// Stores
	addStoreButton: 'admin-add-store-button',
	storeNameInput: 'admin-store-name-input',
	storeDomainInput: 'admin-store-domain-input',
	storeTokenInput: 'admin-store-token-input',
	storeAutoOrderSwitch: 'admin-store-auto-order-switch',
	saveStoreButton: 'admin-save-store-button',
	deleteStoreButton: 'admin-delete-store-button',

	// Products
	addProductButton: 'admin-add-product-button',
	productNameInput: 'admin-product-name-input',
	productPriceInput: 'admin-product-price-input',
	productSkuInput: 'admin-product-sku-input',
	productImageInput: 'admin-product-image-input',
	productVariantInput: 'admin-product-variant-input',
	productShopifyIdInput: 'admin-product-shopify-id-input',
	productStoreSelect: 'admin-product-store-select',
	productDescriptionInput: 'admin-product-description-input',
	productVitrineUrlInput: 'admin-product-vitrine-url-input',
	productVitrineIdInput: 'admin-product-vitrine-id-input',
	productVitrineNameInput: 'admin-product-vitrine-name-input',
	saveProductButton: 'admin-save-product-button',
	deleteProductButton: 'admin-delete-product-button',

	// Snippet
	snippetProductSelect: 'admin-snippet-product-select',
	snippetCopyButton: 'admin-snippet-copy-button',
	snippetCode: 'admin-snippet-code',
	snippetLinkCopyButton: 'admin-snippet-link-copy-button',
};

export const PUBLIC_NAV = {
	logoLink: 'public-logo-link',
	loginLink: 'public-login-link',
	heroCta: 'public-hero-cta',
};
